import { render, staticRenderFns } from "./Companyintroduction.vue?vue&type=template&id=53bc4c34&"
import script from "./Companyintroduction.vue?vue&type=script&lang=js&"
export * from "./Companyintroduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports